module.exports = __webpack_public_path__ + "static/media/29FUNOV10.7aeb6728.jpg";